// Container.tsx
import React, { FC, useContext, ReactNode } from "react";
import {
  ApplicationRootStyle,
  ComponentsAndHeaderRootStyles,
  DecommissionBanner,
  Main,
} from "./container.styled";
import Header from "core/components/layout/header/header";
import Footer from "core/components/layout/footer/footer";
import Dashboard from "core/components/layout/dashboards/standard/dashboard";
import { SidebarProvider } from "core/contexts/sidebar/sidebar";
import { AuthContext } from "core/contexts/auth/auth";
import SidebarMenu from "../sidebar/sidebar";

interface ContainerProps {
  children: ReactNode;
}

const Container: FC<ContainerProps> = ({ children }) => {
  const { afUser } = useContext(AuthContext);

  return (
    <SidebarProvider>
      <ApplicationRootStyle>
        {/* <DecommissionBanner>
          <span className="banner-icon">⚠️</span>
          <span className="banner-text">
            This application is being decommissioned. Please reach out to the{" "}
            <a href="mailto:secai_engineering@accenture.com">
              Cyber Services Engineering
            </a>{" "}
            team if you have any questions.
          </span>
          <span className="banner-icon">⚠️</span>
        </DecommissionBanner> */}
        <Main>
          <SidebarMenu />
          <ComponentsAndHeaderRootStyles>
            <Header />
            <Dashboard name={afUser?.given_name || ""}>{children}</Dashboard>
          </ComponentsAndHeaderRootStyles>
        </Main>
        <Footer />
      </ApplicationRootStyle>
    </SidebarProvider>
  );
};

export default Container;
